@if (loading$ | async) {
  <app-spinner-fullscreen />
}
